import { render, staticRenderFns } from "./CadastroPacientePrimeiraVez.vue?vue&type=template&id=8ec3fc92&"
import script from "./CadastroPacientePrimeiraVez.vue?vue&type=script&lang=js&"
export * from "./CadastroPacientePrimeiraVez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports